module.exports = __webpack_public_path__ + "assets/img/面积图.3b31b3c7.png";